<template>
  <div id="chat-content">
    <div id="messages">
      <TransitionGroup name="messages">
        <chat-message-ce v-for="(message, index) of messages" :key="Math.abs(index-messages.length)"
                         :message="message"
                         :source-order="sourceOrder"
                         :sources="sources">
          <div v-if="message.sender === Sender.AI">
          </div>
        </chat-message-ce>
      </TransitionGroup>
    </div>
    <div v-if="showMore">
      <b-form class="w-100" id="send-div" @submit="sendMessage">
        <b-input-group>
          <b-input placeholder="Ihre Nachfrage" class="shadow-none" name="question_input" required v-model="inputMessage"
                   :disabled="requestState!==RequestState.Done"/>
          <b-button type="submit" variant="primary" :disabled="requestState!==RequestState.Done">
            <i-bi-send/>
          </b-button>
        </b-input-group>
      </b-form>
    </div>
  </div>
</template>
<script setup lang="ts">
import {type Message, RequestState, Sender, type Source} from "@/types.js";
import ChatMessageCe from "@/components/Chat/Message.vue";
import {ref} from "vue";

const props = defineProps<{
  messages: Message[],
  sourceOrder: string[],
  sessionId: string,
  requestState: RequestState,
  showMore: boolean,
  sources: Map<string, Source>
}>()

const inputMessage = ref<string>('');

const emit = defineEmits<{
  (e: 'sendMessage', message: string): void
}>()

function sendMessage(event: Event) {
  event.preventDefault();
  emit('sendMessage', inputMessage.value);
  inputMessage.value = "";
}
</script>

